// extracted by mini-css-extract-plugin
export default {"main":"WorkMain_main__Dln47","modal-open":"WorkMain_modal-open__u3XfX","imgContainer":"WorkMain_imgContainer__rjVhe","imgBox":"WorkMain_imgBox__Zfh-+","img":"WorkMain_img__j-Od3"};